export default __webpack_public_path__ + "static/media/castle.f46433e6.jpg";